import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import {
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';

import { EnableScrollHammerConfig } from '@pnsk/ui-common/components/carousel/enable-scroll-hammer-config';

import { httpInterceptorProviders } from './core/services/http/interceptors';

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        httpInterceptorProviders,
        importProvidersFrom(HammerModule),
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: EnableScrollHammerConfig,
        },
    ],
};
